"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isProfileLimit(object) {
    return checkProfileLimit(object).fulfilled;
}
exports.isProfileLimit = isProfileLimit;
function checkProfileLimit(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("profileId"), __1.hasBoolean("docXReports"), __1.hasBoolean("personalizedReports"), __1.hasBoolean("tagging"), __1.hasBoolean("autoTagging"), __1.hasBoolean("companyTemplates"), __1.hasBoolean("recurringTasks"), __1.hasBoolean("taskDashboard"), __1.hasBoolean("taskTimeDashboard"), __1.hasBoolean("fillableForms"), __1.hasBoolean("signatureInForms"), __1.hasNumber("apiAccessLevel").integer()).withOptions(options).explain();
}
exports.checkProfileLimit = checkProfileLimit;
//# sourceMappingURL=ProfileLimit.js.map